import { useContext } from "react";
import { Button } from "../tailwind/button";
import { CustomerContext } from "../../providers";
import { Heading } from "../tailwind/heading";
import { api } from "../../api";

export const CreateWhatsAppAccount = () => {
  const { customer } = useContext(CustomerContext);

  // Facebook Login with JavaScript SDK
  function launchWhatsAppSignup() {
    // Launch Facebook login
    FB.login(
      (response) => {
        console.log(response);
        if (response.authResponse) {
          const accessToken = response.authResponse.code;
          //Use this token to call the debug_token API and get the shared WABA's ID
          console.log(accessToken);
          try {
            api.customer.update(customer.id, {
              whatsappEmbeddedSignupToken: accessToken,
            });
          } catch (e) {
            console.log(e);
          }
          const result = api.finishEmbeddedSignup({
            accessToken,
            customerId: customer.id,
          });
        } else {
          console.log("User cancelled login or did not fully authorize.");
        }
      },
      {
        config_id: "993629832266228", // configuration ID obtained in the previous step goes here
        response_type: "code", // must be set to 'code' for System User access token
        override_default_response_type: true,
        extras: {
          setup: {
            phone: {
              displayName: customer?.name,
              category: "RETAIL",
            },
          },
          featureType: "whatsapp_business_app_onboarding",
        },
      },
    );
  }

  return (
    <div className="flex flex-col justify-center items-center h-[70vh]">
      <>
        {customer?.waAccessToken && (
          <>
            <Heading className="text-lg mb-5">
              Your WhatsApp account is connected 🎉
            </Heading>
          </>
        )}
        {!customer?.waAccessToken && customer?.isSubscribed && (
          <>
            <button
              onClick={launchWhatsAppSignup}
              style={{
                backgroundColor: "#1877f2",
                border: "0",
                borderRadius: "4px",
                color: "#fff",
                cursor: "pointer",
                fontFamily: "Helvetica, Arial, sans-serif",
                fontSize: "16px",
                fontWeight: "bold",
                height: "40px",
                padding: "0 24px",
              }}
            >
              Continue with Facebook
            </button>
          </>
        )}
      </>
    </div>
  );
};
